/**
 * Mock de la query dataservice `order-user-emails`, dérivé de JSONORD122296.md.
 *
 * Les lignes reproduisent FIDÈLEMENT la forme renvoyée par le dataservice :
 *   - labels de colonnes en minuscules (extractColumnMetadata les met en lower_case) ;
 *   - `businessdata` est une CHAÎNE JSON (colonne jsonb → JDBC OTHER → getObject().toString()),
 *     que parseBusinessData() côté composant re-parse.
 *
 * Note : les données source n'ont pas de clé `_business_data.sender` → le composant retombe
 * sur la colonne `sender` (boîte générique signature.eflo@bodemerauto.com), comportement réel.
 */

/** Business data commune à toutes les lignes de la commande ORD122296. */
function businessData(extra: Record<string, string>): string {
    return JSON.stringify({
        Entity_Reference: "ORD122296",
        Entity_Brand: "RENAULT",
        Entity_Ranges: "CAPTUR",
        Entity_Versions: "ESPRIT ALPINE FULL HYBRID E-TECH 145",
        Entity_Status: "ORDER_NOT_VALIDATED",
        Entity_SellerName: "Vendeur Rihab",
        Entity_PrixVehiculeHt: "28583.33",
        Entity_MargeVehiculeHt: "-3249.17",
        Entity_PrixOptionsHt: "541.667",
        Entity_PrixAchatOptionsHt: "505.75",
        Entity_Id: "CHERBOURG",
        Entity_Daaq: "/BODEMER/",
        front_end_url: "https://kube-distrib.teamwill-digital.com",
        ...extra,
    });
}

/** Une ligne telle que la produirait le SELECT de order-user-emails.xml. */
interface OrderUserEmailRow {
    resourceuid: string;
    createddate: string;
    sentdate: string;
    sender: string;
    recipient: string;
    copyrecipient: string;
    subject: string;
    body: string;
    businessdata: string;
}

const SENDER = "signature.eflo@bodemerauto.com";

export const orderUserEmailsMock: OrderUserEmailRow[] = [
    {
        resourceuid: "email-ORD122296-financement",
        createddate: "2026-07-24 11:33:17",
        sentdate: "2026-07-24 11:33:17",
        sender: SENDER,
        recipient: "bechir.houch@temawillgroup.com",
        copyrecipient: "",
        subject: "Financement",
        body: "Test l rou7i",
        businessdata: businessData({
            signatory_name: "bechir.houch@temawillgroup.com",
            signatory_email: "bechir.houch@temawillgroup.com",
        }),
    },
    {
        resourceuid: "email-ORD122296-commission",
        createddate: "2026-07-23 12:53:26",
        sentdate: "2026-07-23 12:53:26",
        sender: SENDER,
        recipient: "ibrahimayadi78@gmail.com",
        copyrecipient: "",
        subject: "Calcul de commission",
        body: "test e mail",
        businessdata: businessData({
            signatory_name: "ibrahimayadi78@gmail.com",
            signatory_email: "ibrahimayadi78@gmail.com",
        }),
    },
    {
        resourceuid: "email-ORD122296-distribution",
        createddate: "2026-07-22 16:25:47",
        sentdate: "2026-07-22 16:25:47",
        sender: SENDER,
        recipient: "riadh.brinis@efleconnect.com",
        copyrecipient: "",
        subject: "Distribution",
        body: "test",
        businessdata: businessData({
            signatory_name: "riadh.brinis@efleconnect.com",
            signatory_email: "riadh.brinis@efleconnect.com",
        }),
    },
    {
        resourceuid: "email-ORD122296-accessoires",
        createddate: "2026-07-20 15:53:58",
        sentdate: "2026-07-20 15:53:58",
        sender: SENDER,
        recipient: "riadh.brinis@efloconnect.com",
        copyrecipient: "",
        subject: "Accessoires",
        body: "rrrtet",
        businessdata: businessData({
            signatory_name: "riadh.brinis@efloconnect.com",
            signatory_email: "riadh.brinis@efloconnect.com",
        }),
    },
];
